import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router';
import { normalizeChapterSearchParam } from '../../../core/utils/chatUrl';
import { searchParamsValidator } from './-chatSearchParams';
import { loadChatRoute } from './-chatRouteLoader';
import AccessRequestPage from '../../../features/chat/components/accessRequest/AccessRequestPage';

export const Route = createFileRoute('/_app/chat')({
  validateSearch: searchParamsValidator,

  loaderDeps: ({ search }) => ({
    assistant: search.assistant,
    chapter: normalizeChapterSearchParam(search.chapter),
  }),
  loader: loadChatRoute,
  component: ChatLayout,
});

// A denied assistant replaces the chat outlet so no conversation can start.
function ChatLayout() {
  const { accessRequest } = Route.useLoaderData();
  const navigate = useNavigate();
  if (!accessRequest) {
    return <Outlet />;
  }
  return (
    <AccessRequestPage
      assistantName={accessRequest.assistantName}
      ownerEmail={accessRequest.ownerEmail}
      onClose={() => navigate({ to: '/chat', replace: true })}
    />
  );
}
